import styles from "@/components/profile-card.module.css";
import { ProfileCardItem } from "@/types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import clsx from "clsx";
import { JSX } from "react";

interface ProfileCardProps {
	item: ProfileCardItem;
}

function ProfileCard({ item }: ProfileCardProps): JSX.Element {
	const { action, content, icon, label } = item;

	const handleClick = (): void => {
		void action.onClick();
	};

	return (
		<div className={clsx("card", styles["profile-card"])}>
			<div className="row-body">
				<div className={styles["label"]}>
					<FontAwesomeIcon
						fixedWidth
						icon={icon}
						size="xs"
					/>
					{label}
				</div>
				<div className={styles["content"]}>{content || "-"}</div>
			</div>
			<button
				className="action-button"
				onClick={handleClick}
				title={action.title}
				type="button"
			>
				{action.text}
			</button>
		</div>
	);
}

export default ProfileCard;
